export default __webpack_public_path__ + "static/media/cp-img.8b7e5557.png";